import { useCallback, useContext, useMemo } from 'react';
import { useService } from '@core/inversify-react';
import { FormikHelpers } from 'formik';
import { message } from 'antd';
import { useBus } from '@core/event-bus';
import moment from 'moment';

import { CreateInspectionDto } from '../dtos';
import { CreateInspectionContext } from '../contexts';
import { CreateBranchInspectionRepoType, ICreateBranchInspectionRepo } from '../repos';
import { Constants } from '@core/constants';

export const useCreateInspection = () => {
  const { onSucceed } = useContext(CreateInspectionContext);
  const createInspectionRepo = useService<ICreateBranchInspectionRepo>(CreateBranchInspectionRepoType);
  const eventBus = useBus();

  const initialValues = useMemo<CreateInspectionDto>(() => {
    // Default olaraq 48 saat sonra
    const deadline = moment().add(48, 'hours');

    return {
      branchId: '',
      note: 'Qeyd edilən vaxta qədər bütün filialdakı bağlamaları scan etməlisiz!',
      deadline,
    };
  }, []);

  const onSubmit = useCallback(
    async (values: CreateInspectionDto, helpers: FormikHelpers<CreateInspectionDto>) => {
      helpers.setStatus(null);

      const result = await createInspectionRepo.execute({
        branch_id: parseInt(values.branchId),
        note: values.note || undefined,
        deadline: values.deadline?.format(Constants.DATE_TIME) || undefined,
      });

      if (result.status === 200) {
        message.success('Yoxlanış uğurla yaradıldı');
        eventBus.publish({ type: '@branch-inspections/create/succeed' });
        onSucceed?.();
      } else if (result.status === 422) {
        message.error(result.response);
        helpers.setStatus({ message: result.response });
      } else {
        message.error(result.response);
      }
    },
    [createInspectionRepo, eventBus, onSucceed],
  );

  return { onSubmit, initialValues };
};
